export const authorizationStatus = {
  open: 1,
  close: 0
}

export const authorizationDateType = {
  long: 1,
  short: 2
}


// WEBPACK FOOTER //
// ./src/config/workflow/authorization.js